import Constants from "../Constants";

export interface HttpConfig {
    headers: Map<String, String>,
    timeout: number
}

export class HttpClient {

    protected async get(url: string, token?: string): Promise<Response> {
        const headers = this.addTokenHeader(this.getConfig().headers, token)
        const options: RequestInit = {
            method: 'GET',
            headers: Object.fromEntries(headers)
        };
        return this.requestWithTimeout(url, options);
    }

    protected async post(url: string, data: any, token?: string): Promise<Response> {
        const headers = this.addTokenHeader(this.getConfig().headers, token)
        const options: RequestInit = {
            method: 'POST',
            headers: Object.fromEntries(headers),
            body: JSON.stringify(data),
        };
        return this.requestWithTimeout(url, options);
    }

    private getConfig(): HttpConfig {
        return {
            headers: new Map([
                ['Content-Type', 'application/json'],
                ['Accept', 'application/json'],
                ['X-Caller', Constants.APP_NAME],
            ]),
            timeout: Constants.API.TIMEOUT,
        };
    }

    private addTokenHeader(headers: Map<String, String>, token?: string): Map<String, String> {
        if (token) return headers.set('Authorization', `Bearer ${token}`)
        else return headers
    }

    private async requestWithTimeout(url: string, options: RequestInit): Promise<Response> {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), this.getConfig().timeout);

        try {
            const response = await fetch(url, {...options, signal: controller.signal});
            clearTimeout(timeoutId);
            return response;
        } catch (error) {
            clearTimeout(timeoutId);
            throw error;
        }
    }
}
